import { NavLink } from 'react-router-dom';
import { LayoutDashboard, ShoppingCart, ShoppingBag, Package, Menu } from 'lucide-react';
import { ROUTES } from '@/lib/config/routes';
import { type Role } from '@/lib/config/constants';
import { useAuthStore } from '@/store/authStore';
import { cn } from '@/lib/utils/cn';

interface NavItem {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  roles?: Role[];
}

const ITEMS: NavItem[] = [
  { to: ROUTES.dashboard, label: 'Home', icon: LayoutDashboard },
  { to: ROUTES.pos, label: 'Sell', icon: ShoppingCart },
  { to: ROUTES.sales, label: 'Sales', icon: ShoppingBag },
  { to: ROUTES.products, label: 'Stock', icon: Package },
];

export function BottomNav({ onMore }: { onMore: () => void }) {
  const hasRole = useAuthStore((s) => s.hasRole);
  const items = ITEMS.filter((i) => !i.roles || hasRole(...i.roles));

  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 flex h-16 items-stretch border-t border-border bg-surface-elevated pb-[env(safe-area-inset-bottom)] lg:hidden">
      {items.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            cn(
              'flex flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-medium transition',
              isActive ? 'text-brand-600 dark:text-brand-400' : 'text-content-muted',
            )
          }
        >
          {({ isActive }) => (
            <>
              <Icon className={cn('h-5 w-5', isActive && 'scale-110 transition-transform')} />
              {label}
            </>
          )}
        </NavLink>
      ))}
      <button
        type="button"
        onClick={onMore}
        className="flex flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-medium text-content-muted transition active:text-brand-600"
      >
        <Menu className="h-5 w-5" />
        More
      </button>
    </nav>
  );
}
